export default function SaveOverlay({ message }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1200,
      }}
    >
      <div className="card" style={{ padding: "28px 34px", textAlign: "center" }}>
        <div className="spinner" style={{ margin: "0 auto 14px" }} />
        <div style={{ fontWeight: "600" }}>{message || "Lagrer..."}</div>
        <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.6)", marginTop: "6px" }}>
          Vennligst vent
        </div>
      </div>
    </div>
  );
}
